export default __webpack_public_path__ + "static/media/a5_portrait.b578e7b2.png";